import FootnotePopup from './footnote-popup';

export const Footnote = (props) => {
	const { value } = props;
	return <FootnotePopup body={value?.body} />;
};

export default Footnote;
